import Test from '~/pages/Test';

const publicRoutes = [{ path: '/', component: Test, layout: null }];

const privateRoutes = [];

export { publicRoutes, privateRoutes };
